const fontSizes = {};

export default fontSizes;
